export class LoginFormModel {
    constructor(
        public email: string = '',
        public senha: string = '',
        public contratoId: string = ''
    ){}
}